import PropTypes from "prop-types";
import { MobileScreenSolidV6, PhoneSolidV6 } from "@shared/v2/Icomoon";
import Tooltip from "@shared/v2/Tooltip";

const PhoneType = ({ phoneType }) => (
  <>
    {phoneType === "M" && (
      <Tooltip placement="bottom" trigger={<MobileScreenSolidV6 />} content="Mobile Phone" />
    )}
    {(phoneType === "H" || phoneType === "W") && (
      <Tooltip placement="bottom" trigger={<PhoneSolidV6 />} content="Landline" />
    )}
  </>
);

PhoneType.propTypes = {
  phoneType: PropTypes.string.isRequired,
};

export default PhoneType;
